import { ResetBlockCode } from "@redotech/redo-return-core-common/return-actions/reset-blocked-error";
import { ResetExchangeOrderSchema } from "@redotech/redo-return-core-common/return-actions/reset-exchange-order";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getResetReturnEligibility = {
  name: "getResetReturnEligibility" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    blockReason: z
      .object({
        code: z.enum(ResetBlockCode),
        shopifyReturnName: z.string().optional(),
      })
      .optional(),
    exchangeOrders: z.array(ResetExchangeOrderSchema),
  }),
};
